// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2aXlV","container":"styles_container__3T_ke","logo":"styles_logo__WpXlL","name":"styles_name__3MsCW","address":"styles_address__1vZJ4"};